import axios from '_u/axios'

// 反馈列表
export const feedbackList = (body) => {
    return axios.post('api/feed/back/list', body)
}

// 反馈详情
export const feedbackView = (id) => {
    return axios.post('api/feed/back/view', { id })
}

// 反馈回复
export const reply = (body) => {
    return axios.post('api/feed/back/reply', body)
}

// 删除反馈
export const feedbackDel = (id) => {
    return axios.post('api/feed/back/delete', { id })
}